export default __webpack_public_path__ + "static/media/bfa.3dafbce2.svg";